'use client';

import { useEffect, useState } from 'react';

const STORAGE_KEY = 'vanguar_loader_shown';

/** Ported as-is from scripts.js banner 1 — only ever mounted on the index page. */
export default function PageLoader() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // sessionStorage is only available client-side, so this can't be computed
    // during render without a hydration mismatch.
    if (sessionStorage.getItem(STORAGE_KEY)) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoaded(true);
      return;
    }

    const finish = () => {
      setLoaded(true);
      sessionStorage.setItem(STORAGE_KEY, 'true');
    };

    let loadTimer: ReturnType<typeof setTimeout> | undefined;
    const handleLoad = () => {
      loadTimer = setTimeout(finish, 1600);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
    }

    const fallbackTimer = setTimeout(finish, 4000);

    return () => {
      window.removeEventListener('load', handleLoad);
      clearTimeout(loadTimer);
      clearTimeout(fallbackTimer);
    };
  }, []);

  return (
    <div className={`page-loader${loaded ? ' loaded' : ''}`} id="page-loader">
      <div className="loader-text">VANGUAR</div>
    </div>
  );
}
